<app-manage-notes [entityId]="entityId" [entityType]="entityType" [editingNotes]="editingNotes">
</app-manage-notes>
